<template>
  <div class="wrapper">
    <van-cell-group>
    <div class="question">{{num}}.<span>【治疗过程中】</span>您实际<span>建议患儿使用氨基酸配方的时长</span>通常是几个月？（单选）</div>
      
      <van-radio-group v-model="answerObj.remark" @change="changeRemark">
        <van-radio name="A、1~2个月">A、1~2个月</van-radio>
        <van-radio name="B、3~4个月">B、3~4个月</van-radio>
        <van-radio name="C、5~6个月">C、5~6个月</van-radio>
        <van-radio name="D、6个月及以上">D、6个月及以上</van-radio>
      </van-radio-group>
    </van-cell-group>
  </div>
</template>
<script>
export default {
  name: 'typingFirst',
  props: {
    num: {}
  },
  data() {
    return {
      confirm: '',
      form: {
        
      },
      answerObj: {
        sort: '4',
        title: '如果是用于治疗目的，您实际建议患儿使用氨基酸配方的时长通常是几个月？',
        remark: '',
        value: ''
      },
    };
  },
  created() {
    
  },
  methods: {
    changeRemark(e) {
      console.log(this.answerObj)
      this.$emit('getAnswerFourth', e)
      this.confirm = ''
    },
  },
};
</script>

<style lang="less" scoped>
  .question {
    span {
        color: purple;
        font-weight: bold;
    }
  }
  .options {
    /deep/ .el-radio {
      margin-bottom: 10px;
      display: block;
    }
      padding: 10px 10px;
      font-size: 15px;
      margin: 5px 0;
  }
  .operation {
      margin: 10px;
      display: flex;
      justify-content: space-between;
      .total {
          font-size: 16px;
          font-weight: bold;
          line-height: 28px;
      }
  }
</style>
